/**
 * Returns the full S3 object key from a permaUrl, including any owner prefix
 * (e.g. `${userId}/${uuid}.${ext}`). The publish mutation requires the full
 * key — sending only the basename drops the owner prefix and is rejected.
 *
 * Accepts either a full URL or a raw path; falls back to the input string for
 * inputs that can't be parsed as URLs.
 */
export function extractObjectKeyFromPermaUrl(permaUrl: string): string {
  try {
    return new URL(permaUrl).pathname.replace(/^\/+/, "");
  } catch {
    return permaUrl.replace(/^\/+/, "");
  }
}
